import getDateFnsLocaleByIso from 'src/functions/getDateFnsLocaleByIso'
import {
  be,
  kk,
  ru,
  uz,
} from 'date-fns/locale'

describe('getDateFnsLocaleByIso', () => {
  describe('Когда передан iso поддерживаемой страны', () => {
    test.each([
      ['ru', ru],
      ['kk', kk],
      ['uz', uz],
      ['be', be],
    ])('Тогда locale %s', (iso, locale) => {
      expect(getDateFnsLocaleByIso(iso)).toBe(locale)
    })
  })

  describe('Когда передан неизвестный iso', () => {
    test('Тогда locale ru', () => {
      expect(getDateFnsLocaleByIso('en')).toBe(ru)
    })
  })
})
